/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable react/jsx-props-no-spreading */

import React, { useState, useEffect } from 'react';
import {
    object, func, bool, string, arrayOf, shape, array,
    // number,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Grid, TextField, Button, Select, MenuItem,
} from '@material-ui/core';
import States from '../../../../state/constants/States';
import Helper from '../../../../state/reducers/Helper';
// import { formatPhoneNumber } from '../../../../utils/formater';
import { mmoFormatPhoneNumber } from '../../../../utils/formater';
import { main as mainStyle } from '../../../../style/main';
import { deepObjectExtend, isEmpty } from '../../../../utils/object';
import Divider from '../../../../common/Divider';
import { unitBase, rowSpacing } from '../../../../style/variables';
import customBreakpoints from '../../../../../../helpers/customBreakpoints';
import { countryISOAlfa3Codes } from '../../../../state/constants/Countries';

const styles = ({ typography, palette, breakpoints }) => deepObjectExtend(mainStyle(typography, palette), {
    formContainer: {
        marginBottom: '1em',
        [breakpoints.down(customBreakpoints.tabPortrait)]: {
            margin: '2vh 0 0 0',
            height: 'auto',
        },
    },
    nextButton: {
        backgroundColor: palette.colorPrimaryAccountCtaButton,
        color: palette.common.white || '#fff',
        textTransform: 'capitalize',
        fontWeight: 'bold',
        [breakpoints.down(customBreakpoints.tabPortrait)]: {
            borderRadius: '20px',
            marginTop: '8px',
        },
        '&:hover': {
            backgroundColor: palette.colorPrimaryAccountCtaButton,
            opacity: .90,
        },
    },
    lineGridContainer: {
        marginBottom: '5px',
        [breakpoints.down(customBreakpoints.tabPortrait)]: {
            marginBottom: '15px',
        },
    },
    buttonWrap: {
        position: 'sticky',
        bottom: 0,
        backgroundColor: palette.common.white || '#fff',
    },
    selectHandle: {
        // Used contains Mui class name to avoid CSS issue on Account MFE
        '& [class*="MuiOutlinedInput-input"]': {
            padding: '10.5px 14px',
        },
        '& [id="state"]': {
            width: '10rem',
        }
    },
    disabledField: {
        // Used contains Mui class name to avoid CSS issue on Account MFE
        '& [class*="MuiOutlinedInput-input"]': {
            color: palette.colorNeutral60,
        },
    },
    suggestedAddressWrapper: {
        position: 'relative',
        '& .suggested-address': {
            left: unitBase,
            top: '-6px',
            width: 'calc(100vw - 50vw)',
            maxHeight: '151px',
            outline: 'none',
            position: 'absolute',
            'overflow-y': 'scroll',
            'border-bottom-left-radius': unitBase,
            'border-bottom-right-radius': unitBase,
            'background-color': '#fff',
            'z-index': 2,
            '-webkit-box-shadow':
                '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
            [breakpoints.down(customBreakpoints.tabPortrait)]: {
                width: `calc(100vw - ${rowSpacing * 4}px - ${unitBase * 8}px)`,
            },
            '& > li': {
                padding: `${unitBase * 2}px`, // trying to fit 7 suggested addresses in the dropdown
                'margin-right': unitBase * 2,
                overflow: 'hidden',
                'white-space': 'nowrap',
                fontSize: '16px',
                minHeight: rowSpacing * 3,
            },
        },
    },
    hideNextBtn: {
        display: 'none',
    },
    desktopAddressBookStyle: {
        width: '100%',
        margin: 0,
        '& .addressVerifyWrapper': {
            margin: '24px 0',
            textAlign: 'center',
            '& button': {
                backgroundColor: palette.colorPrimaryAccountCtaButton,
                color: palette.common.white || '#fff',
                [breakpoints.down(customBreakpoints.tabPortrait)]: {
                    fontSize: '16px',
                },
            },
        },
        '& button': {
            backgroundColor: palette.colorPrimaryAccountCtaButton,
            color: palette.common.white || '#fff',
            margin: '10px',
            [breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: '16px',
            },
        },
    },
});

const ModifyRecipientAddress = ({
    featureFlags, recipientAddressObj, getModifiedRecipientAddress, classes, isMobile,
    productBrand, handleSearchAddress, searchResults, searchError, handleSelectedAddress, selectedAddress,
    getIsRecipientFormValid, handleSetVerificationState, handleVerifyAddress, isAddressVerification, clearAddressVerification,
    // currentTab,
    // goToNextTab,
    changeTabs,
    modifyEligibility,
    checkForConfirmationScreen,
    productType,
}) => {
    const states = Helper.refactorStateData(States);
    const [recipientAddress, setRecipientAddress] = useState(recipientAddressObj);
    const [showSuggestedDropdown, setShowSuggestedDropdown] = useState(false);
    const [selectedSearchAddress, setSelectedSearchAddress] = useState(false);
    const [isVerificationNeeded, setIsVerificationNeeded] = useState(true);
    const [confirmAddress, setConfirmAddress] = useState(false);
    const [keepAddressClicked, setKeepAddressClicked] = useState(false);
    const [suggestedSelectAddress, setsuggestedSelectAddress] = useState(0);
    const isHDBrand = ['1018', '1019', '1020', '1031'].includes(productBrand);
    const isFoodGPT = productType === 'GPT' && ['1018', '1019', '1020', '1002', '1012', '1031'].includes(productBrand); // STK, HD, WLF, TPF, CCO, VC
    const isFloralGPT = productType === 'GPT' && ['1001', '1029', '1025', '1009'].includes(productBrand); // 18F, SB, SCH, 18B
    const isFloralFPT = productType === 'FPT' && ['1001', '1010', '1029'].includes(productBrand); // 18F, FB, SB
    const getDropdownMenuOptions = () => {
        const floralDefaultOptions = ['Residence', 'Business'];
        const foodGPTOptions = ['Residence', 'Business', 'P.O.Box', 'APO/FPO'];
        const floralFPTGPTOptions = ['Residence', 'Business', 'Funeral Home', 'Hospital', 'Apartment', 'School', 'Church'];
        let dropDownOptions = '';
        if (isFoodGPT) dropDownOptions = foodGPTOptions; // Food GPT
        else if (isFloralGPT) dropDownOptions = floralFPTGPTOptions; // Floral GPT
        else if (isFloralFPT) dropDownOptions = floralFPTGPTOptions; // Floral FPT
        else dropDownOptions = floralDefaultOptions; // Default
        return dropDownOptions;
    };
    const [error, setError] = useState({
        firstName: '',
        lastName: '',
        company: '',
        addressLine1: '',
        addressLine2: '',
        cityName: '',
        zipCode: '',
        country: '',
        phoneNumber: '',
    });
    const [isError, setIsError] = useState(false);
    const [selectedLocationType, setSelectedLocationType] = useState(recipientAddressObj.locationType);

    // To validate all the required field of form
    const checkFormValid = () => {
        const validForm = Object.entries(error).map(([key]) => error[key]);
        if (validForm.includes('This field is required')) {
            setIsError(true);
        }
    };

    // Validates phone field in MMO
    // Returns true if recipient number string Matches 10 preceding digits
    const isPhoneValid = (recipientPhoneNumber) => {
        const validPhoneRegx = /^(\d{10}|)$/;
        const formattedRecipientNumber = recipientPhoneNumber.replace(/\D/g, '');
        return formattedRecipientNumber.match(validPhoneRegx);
    };


    const TypeCheck = {
        Numeric: (data) => {
            const inputVal = data.value.toString();
            const onlyNumbers = inputVal.replace(/[^0-9]/g, '');
            return onlyNumbers;
        },
        Alpha: (data) => {
            const inputVal = data.value.toString()
            const onlyLetters = inputVal.replace(/[^a-zA-Z ]+/g, '');
            return onlyLetters
        }
    };

    const clearErrorState = () => {
        setError({
            ...error,
            addressLine1: '',
            addressLine2: '',
            cityName: '',
            zipCode: '',
            country: '',
        })
        setIsError(false)
    }

    // This is to validate required field on blur
    const handleFormValidations = (field, input) => {
        if (field === 'locationType') {
            if ((['Business', 'Funeral Home', 'Hospital', 'School', 'Church'].indexOf(input) > -1) && recipientAddress.company === '') {
                setError({
                    ...error,
                    company: 'This field is required',
                    addressLine2: '',
                });
                setIsError(true);
            } else if (input === 'Apartment' && recipientAddress.addressLine2 === '') {
                setError({
                    ...error,
                    addressLine2: 'This field is required',
                    company: '',
                });
                setIsError(true);
            } else {
                setError({
                    ...error,
                    company: '',
                    addressLine2: '',
                });
                setIsError(false);
            }
        } else if ((input === '' && field === 'company' && (['Residence', 'Apartment', 'P.O.Box', 'APO/FPO'].indexOf(recipientAddress.locationType) > -1))
            || (input === '' && field === 'addressLine2' && recipientAddress.locationType !== 'Apartment')) {
            setError({
                ...error,
                [field]: '',
            });
            setIsError(false);
        } else if ((input === '' && field !== 'country') || (input === '' && field === 'addressLine2' && recipientAddress.locationType === 'Apartment')) {
            setError({
                ...error,
                [field]: 'This field is required',
            });
            setIsError(true);
        }
        else if (field === 'phoneNumber' && !isPhoneValid(input)) {
            setError({
                ...error,
                [field]: 'Please enter a valid phone number',
            });
            setIsError(true);
        } else if (field === 'zipCode' && input.length > 5) {
            setError({
                ...error,
                [field]: 'Please enter a valid zip code',
            });
            setIsError(true);
        } else if ((field === 'firstName' || field === 'lastName') && input.length < 1) {
            setError({
                ...error,
                [field]: 'This field is required',
            });
            setIsError(true);
        } else {
            setError({
                ...error,
                [field]: '',
            });
            setIsError(false);
        }
    };

    const getFullAddressString = () => {
        let fullAddress = recipientAddress.addressLine1;
        if (recipientAddress.addressLine2 && recipientAddress.addressLine2.trim()) {
            fullAddress += ` ${recipientAddress.addressLine2.trim()}, `;
        } else {
            fullAddress += ', ';
        }
        if (recipientAddress.cityName && recipientAddress.cityName.trim()) {
            fullAddress += `${recipientAddress.cityName.trim()} `;
        }
        if (recipientAddress.state) {
            fullAddress += `${recipientAddress.state} `;
        }
        if (recipientAddress.zipCode) {
            fullAddress += recipientAddress.zipCode;
        }
        return fullAddress;
    };

    const handleInputChange = (field, input, inputType = null) => {
        let inputVal = input;
        if (!!inputVal && (field === 'addressLine1' || field === 'addressLine2') && !inputVal.match(/^[a-zA-Z0-9 !@#&()_+:"?,;'.-]+$/g)) return;

        const restrictInput = TypeCheck[inputType] || false;

        // Here we type check values in fields using functions that are defined in the TypeCheck object
        // Each inputType needs to be specified in the TextFieldWrapper field for each input (i.e. zipCode)
        // And your preferred type check function needs to be added to the TypeCheck object
        if (restrictInput) {
            inputVal = restrictInput({ value: input });
        }
        setRecipientAddress({
            ...recipientAddress,
            [field]: inputVal,
        });


        if (field === 'locationType') {
            if (inputVal !== 'APO/FPO' && recipientAddress?.cityName?.toLowerCase() === 'apo') {
                setRecipientAddress({
                    ...recipientAddress,
                    company: '',
                    cityName: '',
                    state: states.US[0].id,
                    locationType: inputVal,
                });
            } else {
                setRecipientAddress({
                    ...recipientAddress,
                    company: '',
                    locationType: inputVal,
                });
            }
            setSelectedLocationType(inputVal); // To set current selected location Type
        }
        if (field === 'suggestedAddress') {
            setsuggestedSelectAddress(inputVal);
        }
        handleFormValidations(field, inputVal); // To handle validations
    };

    const handleKeepAddressClicked = (click) => {
        const { isDeliveryDateModifiable, isCardMsgModifiable } = modifyEligibility;
        getModifiedRecipientAddress(recipientAddress);
        if (isDeliveryDateModifiable === true) {
            changeTabs(1);
        } else if (isCardMsgModifiable === true) {
            changeTabs(2);
        } else {
            checkForConfirmationScreen(true);
        }
        setConfirmAddress(false);
        if (click) {
            setKeepAddressClicked(true);
        }
        if (!isEmpty(searchResults) && isAddressVerification) {
            clearAddressVerification();
        }
    };

    const renameKey = (obj, key, newKey) => {
        const clonedObj = ({ ...obj });
        const targetKey = clonedObj[key];
        delete clonedObj[key];
        clonedObj[newKey] = targetKey;
        return clonedObj;
    };

    const hasSuggestedAddress = (newSearchResults) => {
        let isSuggested = true;
        if (!isEmpty(selectedAddress)) {
            // Compare every input field with the selectedAddress
            let newRecipientAddress = { ...recipientAddress };
            newRecipientAddress = renameKey(newRecipientAddress, 'addressLine1', 'street');
            newRecipientAddress = renameKey(newRecipientAddress, 'addressLine2', 'apt');
            newRecipientAddress = renameKey(newRecipientAddress, 'cityName', 'city');
            newRecipientAddress = renameKey(newRecipientAddress, 'zipCode', 'zipcode');

            Object.keys(selectedAddress).forEach((item) => {
                if (selectedAddress[item] !== newRecipientAddress[item]) {
                    isSuggested = false;
                }
            });
        } else {
            isSuggested = false;
        }
        const fullAddress = getFullAddressString();
        const suggestedList = !isEmpty(newSearchResults) ? newSearchResults : searchResults;
        if (!isEmpty(suggestedList)) {
            // Compare full address with the suggestedList
            suggestedList.forEach((item) => {
                const adjustString = (str) => str.toUpperCase().replace(/\s/g, ''); // to get rid of space and letters mismatch
                if (adjustString(item.suggestion) === adjustString(fullAddress)) {
                    isSuggested = true;
                }
            });
        }
        return isSuggested;
    };

    const verifyAddress = () => {
        const isoCountryCode = countryISOAlfa3Codes[recipientAddress.country];
        const params = {
            query: getFullAddressString(),
            country: isoCountryCode,
            take: 20,
        };
        handleVerifyAddress(params);
    };

    useEffect(() => () => {
        getModifiedRecipientAddress(recipientAddress);
    }, [recipientAddress]);

    useEffect(() => {
        // To set default selected option for city and state while locationType is APO/FPO selected
        if (selectedLocationType === 'APO/FPO') {
            if ((['APO', 'FPO'].indexOf(recipientAddress.cityName) === -1) && (['AA', 'AE', 'AP'].indexOf(recipientAddress.state) === -1)) {
                setRecipientAddress({
                    ...recipientAddress,
                    cityName: 'APO',
                    state: 'AA',
                });
            }
        }
    }, [selectedLocationType]);

    useEffect(() => {
        // To setting the selected address into the respective fileds
        if (!isEmpty(selectedAddress) && selectedSearchAddress) {
            setRecipientAddress({
                ...recipientAddress,
                addressLine1: selectedAddress.street,
                addressLine2: selectedAddress.apt,
                addressLine3: '',
                cityName: selectedAddress.city,
                state: selectedAddress.state,
                zipCode: selectedAddress.zipcode,
            });
        }
        clearErrorState()
    }, [selectedAddress]);

    useEffect(() => {
        checkFormValid();
        getIsRecipientFormValid(isError);
    }, [isError]);

    useEffect(() => {
        if (!isEmpty(selectedAddress) && selectedSearchAddress) {
            recipientAddress.addressLine1 = selectedAddress.street;
            recipientAddress.addressLine2 = recipientAddress.addressLine2 === '' ? selectedAddress.apt : recipientAddress.addressLine2;
            recipientAddress.cityName = selectedAddress.city;
            recipientAddress.state = selectedAddress.state;
            recipientAddress.zipCode = selectedAddress.zipcode;
            recipientAddress.country = selectedAddress.country;
            setRecipientAddress(recipientAddress);
            setSelectedSearchAddress(false);
            if (!isVerificationNeeded) {
                handleKeepAddressClicked();
            } else if (!keepAddressClicked) {
                setConfirmAddress(true);
            }
        } else if (isAddressVerification && !confirmAddress && isVerificationNeeded) {
            const hasAddress = hasSuggestedAddress(searchResults);
            if (hasAddress) {
                // Keep Address
                setIsVerificationNeeded(false);
                handleKeepAddressClicked();
            } else {
                setConfirmAddress(true);
            }
        }
    }, [isAddressVerification, isVerificationNeeded]);

    const goToNextTab = () => {
        const isMyAccountQasOn = featureFlags?.['is-my-account-qas-on'] || false;
        const qasError = searchError?.Message?.length > 0 || false;
        if (isMyAccountQasOn && !qasError && !confirmAddress && isVerificationNeeded && !hasSuggestedAddress()) {
            verifyAddress();
        } else {
            setIsVerificationNeeded(false);
            handleKeepAddressClicked();
        }
    };

    const hideSuggestedAddress = () => {
        setShowSuggestedDropdown(false);
    };

    const handleSelectAnAddress = (address) => {
        setSelectedSearchAddress(true);
        handleSelectedAddress(address);
        hideSuggestedAddress();
    };

    const showSuggestions = () => {
        if (!isEmpty(searchResults) && showSuggestedDropdown) {
            return (
                <div className={classes.suggestedAddressWrapper}>
                    <div className="suggested-address">{
                        searchResults.map((address) => (
                            <MenuItem
                                key={address.suggestion}
                                onClick={() => handleSelectAnAddress(address)}
                            >
                                {address.suggestion}
                            </MenuItem>
                        ))
                    }
                    </div>
                </div>
            );
        }
        return null;
    };

    const handleStreetKeyPress = (input) => {
        const street = input;
        if (street.length > 3 && street.trim()) {
            const isoCountryCode = countryISOAlfa3Codes[recipientAddress.country];
            const params = {
                query: `${street}, ${recipientAddress?.cityName?.trim()} ${recipientAddress?.state} ${recipientAddress?.zipCode}`,
                country: isoCountryCode,
                take: 25,
            };
            handleSearchAddress(params);
        }
    };

    const showSuggestedAddress = (input) => {
        if (!showSuggestedDropdown) {
            setShowSuggestedDropdown(true, () => {
                handleStreetKeyPress(input);
            });
        }
    };
    const onChangeLocationType = () => {
        switch (selectedLocationType) {
            case 'Funeral Home':
                return 'Funeral Home Name*';
            case 'Hospital':
                return 'Hospital Name*';
            case 'School':
                return 'School Name*';
            case 'Church':
                return 'Church Name*';
            default:
                return error?.company !== '' ? 'Company Name*' : 'Company Name';
        }
    };

    const onChangePoBoxOrApoFpo = () => {
        // for addressLine1 field instead of Delivery Address we are displaying respective name
        // when user select P.O.Box or APO/FPO
        switch (selectedLocationType) {
            case 'P.O.Box':
                return 'P.O.Box*';
            case 'APO/FPO':
                return 'Unit/Ship/PSC Number*';
            default:
                return 'Delivery Address*';
        }
    };

    const availableStatesForAPOFPO = () => {
        // when APO/FPO selected only below three states are available
        const availableStates = states.US.filter((s) => s.id === 'AA' || s.id === 'AE' || s.id === 'AP');
        return availableStates;
    };

    const handleChooseSeletedAddress = (searchResultsData) => {
        if (!isEmpty(searchResultsData) && searchResultsData[suggestedSelectAddress].format) {
            const address = searchResultsData[suggestedSelectAddress];
            // Get select address and submit data
            handleSelectAnAddress(address);
            setTimeout(() => {
                handleKeepAddressClicked();
            }, 1000);
        }
    };

    const handleEditAddressClicked = () => {
        setConfirmAddress(false);
        setTimeout(() => { // because we need this props/state to be updated after get back to the recipient form page
            handleSetVerificationState(false);
            setIsVerificationNeeded(true);
        }, 1000);
    };

    const getAddressLine2 = () => {
        let addressLine2 = 'APT / Suite / Room';
        if (selectedLocationType === 'APO/FPO') {
            addressLine2 = 'Box/Hull Number';
        } else if (recipientAddress.locationType === 'Apartment') {
            addressLine2 = 'APT / Suite / Room*';
        }
        return addressLine2;
    };

    const TextFieldWrapper = (xs, placeHolder, fieldName, value, selectOptions, isFieldDisabled, maxChars, inputType) => (
        <Grid item xs={xs}>
            {!selectOptions
                ? (
                    <>
                        <TextField
                            fullWidth
                            value={value}
                            variant={isMobile ? 'standard' : 'outlined'}
                            size="small"
                            placeholder={placeHolder}
                            onKeyUp={fieldName === 'addressLine1' && ((e) => handleStreetKeyPress(e.target.value))}
                            onClick={fieldName === 'addressLine1' ? ((e) => showSuggestedAddress(e.target.value)) : (() => hideSuggestedAddress())}
                            onChange={(e) => handleInputChange(fieldName, e.target.value, inputType)}
                            inputProps={{ disabled: isFieldDisabled, maxLength: maxChars || null }}
                            className={isFieldDisabled ? classes.disabledField : ''}
                            error={error?.[fieldName] !== ''}
                            helperText={error?.[fieldName] !== '' ? error?.[fieldName] : ''}
                        />
                        {fieldName === 'addressLine1' && showSuggestions()}
                    </>
                )
                : (
                    <Select
                        fullWidth
                        value={value}
                        id={fieldName}
                        className={classes.selectHandle}
                        variant={isMobile ? 'standard' : 'outlined'}
                        onChange={(e) => handleInputChange(fieldName, e.target.value)}
                    >
                        {
                            selectOptions.map((option) => (
                                <MenuItem key={`select${option.id || option.id === 0 ? option.id : option}`} value={option.id || option.id === 0 ? option.id : option}>{option.name ? option.name : option}</MenuItem>
                            ))
                        }
                    </Select>
                )}
        </Grid>
    );

    const confirmationLayout = () => {
        if (!confirmAddress) return null;

        const isoCountryCode = countryISOAlfa3Codes[recipientAddress.country];
        const address = <div style={{ fontSize: '16px' }} className="margin-top-2x margin-bottom-2x"><div>{recipientAddress.addressLine1} {recipientAddress.addressLine2}</div><div>{recipientAddress.cityName}, {recipientAddress.state} {recipientAddress.zipCode}</div><div>{isoCountryCode}</div></div>;
        const suggestedList = [];
        if (!isEmpty(searchResults)) {
            searchResults.forEach((item, index) => {
                suggestedList.push({ id: index, name: item.suggestion });
            });
        }
        let textInfo = isEmpty(suggestedList) ? (<p style={{ fontSize: '16px' }} className="bold margin-top">We could not find a match to the address:</p>) : '';
        textInfo = !isVerificationNeeded ? (<p className="bold margin-top">You have selected address:</p>) : textInfo;
        let textOptions = isEmpty(suggestedList) ? (<p style={{ fontSize: '16px' }} className="bold">Please choose one of the options below to proceed</p>) : '';
        textOptions = isVerificationNeeded ? textOptions : '';
        return (
            <>
                <div className={`${classes.main} ${classes.desktopAddressBookStyle}`}>
                    <h2 className="margin-top-2x margin-bottom-2x">Address Verification</h2>
                    {textInfo}
                    {!isEmpty(suggestedList) ? (
                        <>
                            <p className="margin-bottom-2x">According to the USPS&reg; the street number you entered is either missing or incorrect. Please refer to the list of options below.</p>
                            <p className="h2">Choose Recommended Address Below:</p>
                            <div className="align-center">
                                {TextFieldWrapper(
                                    12,
                                    'Suggested Address',
                                    'suggestedAddress',
                                    suggestedSelectAddress,
                                    suggestedList,
                                )}
                                <div className="addressVerifyWrapper">
                                    <Button
                                        variant="contained"
                                        className="buttonVerify"
                                        onClick={() => handleChooseSeletedAddress(searchResults)}
                                    >
                                        Choose Address
                                    </Button>
                                </div>
                            </div>
                            <Divider text="or" />
                            <p className="bold margin-top h2">Keep or edit original address:</p>
                        </>
                    ) : ''}
                    {address}
                    {textOptions}
                    <div className="align-center buttons-wrapper">
                        <Button
                            variant="contained"
                            className={`${classes.nextButton} ${isVerificationNeeded ? 'red width-auto' : ''}`}
                            onClick={() => handleEditAddressClicked()}
                        >
                            {!isVerificationNeeded ? 'Saving Address...' : 'Edit Address'}
                        </Button>
                        <Button
                            variant="contained"
                            className={`${classes.nextButton} outline width-auto ${!isVerificationNeeded ? 'display-none' : ''}`}
                            onClick={() => handleKeepAddressClicked(true)}
                        >
                            Keep Address
                        </Button>
                    </div>
                </div>
            </>
        );
    };
    const desktopFormView = () => {
        if (confirmAddress) {
            return confirmationLayout();
        }
        return (
            <form className={classes.formContainer}>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {TextFieldWrapper(6, 'First Name*', 'firstName', recipientAddress.firstName, null, isHDBrand, 25, 'Alpha')}
                    {TextFieldWrapper(6, 'Last Name*', 'lastName', recipientAddress.lastName, null, isHDBrand, 25, 'Alpha')}
                </Grid>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {TextFieldWrapper(6, 'Location Type*', 'locationType', recipientAddress.locationType, getDropdownMenuOptions(), 2)}
                    {TextFieldWrapper(6, onChangeLocationType(), 'company', recipientAddress.company, null, null, 100, null)}
                </Grid>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {TextFieldWrapper(12, onChangePoBoxOrApoFpo(), 'addressLine1', recipientAddress.addressLine1)}
                </Grid>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {TextFieldWrapper(12, getAddressLine2(), 'addressLine2', recipientAddress.addressLine2)}
                </Grid>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {selectedLocationType === 'APO/FPO'
                        ? TextFieldWrapper(4, 'APO/FPO*', 'cityName', recipientAddress.cityName, ['APO', 'FPO'])
                        : TextFieldWrapper(4, 'City*', 'cityName', recipientAddress.cityName)}
                    {TextFieldWrapper(4, 'State', 'state', recipientAddress.state, selectedLocationType === 'APO/FPO' ? availableStatesForAPOFPO() : states.US)}
                    {TextFieldWrapper(4, 'Zip/Postal Code*', 'zipCode', recipientAddress.zipCode, null, null, 5, 'Numeric')}
                </Grid>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {TextFieldWrapper(6, 'United States*', 'country', 'United States')}
                    {TextFieldWrapper(6, 'Recipient Phone Number', 'phoneNumber', mmoFormatPhoneNumber(recipientAddress.phoneNumber), null, true)}
                </Grid>
            </form>
        );
    };

    const mobileFormView = () => {
        if (confirmAddress) {
            return confirmationLayout();
        }
        return (
            <form className={classes.formContainer}>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {TextFieldWrapper(6, 'First Name*', 'firstName', recipientAddress.firstName, null, isHDBrand, 25, 'Alpha')}
                    {TextFieldWrapper(6, 'Last Name*', 'lastName', recipientAddress.lastName, null, isHDBrand, 25, 'Alpha')}
                </Grid>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {TextFieldWrapper(12, 'Location Type*', 'locationType', recipientAddress.locationType, getDropdownMenuOptions())}
                </Grid>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {TextFieldWrapper(12, onChangeLocationType(), 'company', recipientAddress.company, null, null, 100, null)}
                </Grid>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {TextFieldWrapper(12, onChangePoBoxOrApoFpo(), 'addressLine1', recipientAddress.addressLine1)}
                </Grid>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {TextFieldWrapper(12, getAddressLine2(), 'addressLine2', recipientAddress.addressLine2)}
                </Grid>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {selectedLocationType === 'APO/FPO'
                        ? TextFieldWrapper(12, 'APO/FPO*', 'cityName', recipientAddress.cityName, ['APO', 'FPO'])
                        : TextFieldWrapper(12, 'City*', 'cityName', recipientAddress.cityName)}
                </Grid>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {TextFieldWrapper(6, 'State', 'state', recipientAddress.state, selectedLocationType === 'APO/FPO' ? availableStatesForAPOFPO() : states.US)}
                    {TextFieldWrapper(6, 'Zip/Postal Code*', 'zipCode', recipientAddress.zipCode, null, null, 5, 'Numeric')}
                </Grid>
                <Grid container spacing={2} className={classes.lineGridContainer}>
                    {TextFieldWrapper(6, 'United States*', 'country', 'United States')}
                    {TextFieldWrapper(6, 'Recipient Phone Number', 'phoneNumber', mmoFormatPhoneNumber(recipientAddress.phoneNumber), null, true)}
                </Grid>
            </form>
        );
    };

    return (
        <Grid>
            {isMobile ? mobileFormView() : desktopFormView()}
            <Grid container xs={12} spacing={2} justify="flex-end" className={confirmAddress ? classes.hideNextBtn : classes.buttonWrap}>
                <Grid item xs={12} sm={6} md={6}>
                    <Button variant="contained" className={classes.nextButton} fullWidth color="primary" onClick={goToNextTab} disabled={isError}>Next</Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

ModifyRecipientAddress.propTypes = {
    featureFlags: object.isRequired,
    recipientAddressObj: object.isRequired,
    getModifiedRecipientAddress: func.isRequired,
    classes: object.isRequired,
    changeTabs: func.isRequired,
    isMobile: bool.isRequired,
    productBrand: string.isRequired,
    handleSearchAddress: func.isRequired,
    searchResults: arrayOf(
        shape({
            suggestion: string,
            matched: array,
            format: string,
        }).isRequired,
    ).isRequired,
    searchError: object.isRequired,
    getIsRecipientFormValid: func.isRequired,
    handleSelectedAddress: func.isRequired,
    selectedAddress: shape({
        street: string,
        apt: string,
        city: string,
        state: string,
        country: string,
        zipcode: string,
    }).isRequired,
    handleSetVerificationState: func.isRequired,
    handleVerifyAddress: func.isRequired,
    isAddressVerification: bool.isRequired,
    clearAddressVerification: func.isRequired,
    modifyEligibility: shape({
        isRecipientModifiable: bool,
        isDeliveryDateModifiable: bool,
        isCardMsgModifiable: bool,
    }).isRequired,
    checkForConfirmationScreen: func.isRequired,
    productType: string.isRequired,
    // currentTab: number.isRequired,
};

const StyledModifyRecipientAddress = withStyles(styles)(ModifyRecipientAddress);

export default StyledModifyRecipientAddress;
